




















import { computed, defineComponent, toRefs } from '@vue/composition-api';

const name = 'ttam-schedule-endtime-datepicker';

export default defineComponent({
  name,
  props: {
    value: {
      type: String,
      required: true,
    },
    starttime: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    timezoneOffset: {
      type: Number,
      default: 0,
    },
    disableScrollControl: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { starttime } = toRefs(props);
    const bottomShortcuts = [];
    const endDisabledDateSetter = cur => {
      const startDate = new Date(starttime.value);
      startDate.setHours(0);
      startDate.setMinutes(0);
      startDate.setSeconds(0);

      return cur - startDate.valueOf() < 0;
    };

    return {
      name,
      endDisabledDateSetter,
      bottomShortcuts,
      _endTime: computed({
        get: () => props.value,
        set: v => {
          emit('change', v);
          emit('input', v);
        },
      }),
    };
  },
});
